<template>
	<div>
		<div class="page_cover  page_shadow">
			<div class="header">
				<div class="line"></div>
				<h3>学习力测评报告</h3>
			</div>
			<div class="main">
				<p>{{user.grade}}</p>
				<p>{{user.class_name}}</p>                
				<p>{{user.realname}}</p>
			</div>
		</div>
		<div class="page_meaasge  page_shadow">
			<div class="table_box">
				<table class="table">
					<tr class="t_title"><td colspan="2">测评者基本信息</td></tr>
					<tr>
						<td>姓名</td><td>{{user.realname}}</td>
					</tr>
					<tr>
						<td>学校</td><td>{{user.school}}</td>
					</tr>
					<tr>
						<td>年级</td><td>{{user.grade}}</td>
					</tr>
				</table>
				<table class="table">
					<tr class="t_title"><td colspan="2">测评完成情况</td></tr>
					<tr>
						<td>测评日期</td><td>{{formatDate(user.updated_at)}}</td>
					</tr>
					<tr v-if="user.cehuang">
						<td>信度指数</td><td>{{user.cehuang}}</td>
					</tr>
				</table>
				<table class="gailan">
					<tr class="t_title">测评结果概览</tr>
					<tr v-if="total.constructor === Object">
						<p>总体而言，你的学习力水平值为：<span>{{total.score | toFixed(2)}}</span>
							<template v-if="total.percent"> ，超过了<span class="c_percent">{{total.percent*100 | toFixed(2)}}%</span>的同龄人</template></p>
					</tr>
					<tr v-if="part1Total">
						<p>你的学习潜力水平值为：<span>{{part1Total.score | toFixed(2)}}</span><template v-if="part1Total.percent"> ，超过了<span class="c_percent">{{part1Total.percent*100 | toFixed(2)}}%</span>的同龄人</template></p>
					</tr>
					<tr v-if="part2Total">
						<p>你的学习动力水平值为：<span>{{part2Total.score | toFixed(2)}}</span><template v-if="part2Total.percent"> ，超过了<span class="c_percent">{{part2Total.percent*100 | toFixed(2)}}%</span>的同龄人</template></p>
					</tr>
					<tr v-if="part3Total&&part3Total.score">
						<p>你的学习效力水平值为：<span>{{part3Total.score | toFixed(2)}}</span><template v-if="part3Total.percent"> ，超过了<span class="c_percent">{{part3Total.percent*100 | toFixed(2)}}%</span>的同龄人</template></p>
					</tr>
				</table>
				<!-- （逻辑算法：比学习力出众百分比低的项为有待进一步提高的项） -->
				<table class="gailan" v-if="isJianyi">
					<tr class="t_title">专家建议</tr>
					<tr>
						<p>相对而言，你的{{isJianyi}}有待进一步提高。</p>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
export default {
    props: {
    	user: {
    		type: Object
    	},
    	total: {
	        type: Object | Array
	    },
	    part1Total: {
	        type: Object
	    },    	
	    part2Total: {
	        type: Object
	    },
	    part3Total: {
	        type: Object
	    }
    },
    data() {
        return {
        }
    },
    computed: {
    	score1() {
    		if (this.part1Total) {
    			return this.part1Total.percent;
    		}else {
    			return '';
    		}
    		
    	},
    	score2() {
    		if (this.part2Total) {
    			return this.part2Total.percent;
    		}else {
    			return '';
    		}
    	},
    	score3() {
    		if (this.part3Total) {
    			return this.part3Total.percent;
    		}else {
    			return '';
    		}
    	},
    	isJianyi() {
    		let score1 = this.score1;
    		let score2 = this.score2;
    		let score3 = this.score3;
    		let arr = [];
    		if(score1&&score2&&score3) {
    			if(score1==score2&&score1==score3) {
    				return false;
    			}
    			arr = [
    				{ 'score': score1, name: '学习潜力' },
    				{ 'score': score2, name: '学习动力' },
    				{ 'score': score3, name: '学习效力' }
    			];
    			arr.sort(function(a, b){return b.score - a.score});
    			if(arr[1].score == arr[2].score) {
    				return arr[1].name + '、' + arr[2].name 
    			}else {
    				return arr[2].name
    			}
    		}else {
    			return false;
    		}
    	}
    },
    watch: {
    },
    created() {	
    },
    methods: {
    	getJianyi() {
    		let total1 = this.part1Total;
    		let total2 = this.part1Tota2;
    		let total3 = this.part1Tota3;
    		let arr = [];
    		if(total1&&total2&&total3) {

    		}
    	},
    	formatDate(date) {
			var date = new Date(date);
			var YY = date.getFullYear() + '-';
			var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
			var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
			var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
			var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
			var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
			return YY + MM + DD +" "+hh + mm + ss;
		}
    },
    mounted() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
	@import './report.less';
	.page_cover {
		background: url(~@/assets/report_imgs/page_cover.jpg);
		background-size: 900px 1300px;
		padding-top: 545px !important;
		.header {
			margin-bottom: 400px;
			.line {
				width: 85px;
				height: 8px;
				border-radius: 4px;
				background-color: #fff;
			}
			h3 {
				line-height: 150px;
				font-size: 56px;
				color: #fff;
			}
		}
		.main {
			padding-right: 40px;
			display: flex;
			justify-content: flex-end;
			p {
				font-size: 24px;
				padding: 0 25px;
			}
		}

	}
	.page_meaasge {
		.table_box {
			.table {
				text-align: center;
				margin-bottom: 50px;
				.t_title {
					width: 100%;
					background-color: #41CBAA;
					border: 1px solid #C8CED7;
					color: #fff;
					td {
						line-height: 45px;
						font-size: 20px;
					}
				}
				tr {
					td {
						width: 50%;
						line-height: 42px;
						border: 1px solid #C8CED7;
						font-size: 16px;
					}
				}
			}
			.gailan {
				margin-bottom: 50px;
				tr {
					line-height: 80px;
					border: 1px solid #C8CED7;
					padding-left: 20px;
					p {
						padding-left: 20px;
						display: flex;
						line-height: 32px;
						height: 80px;
						align-items: center;
						span {
							font-size: 18px;
							font-weight: bold;
							color: #F87608;
						}
						.c_percent {
							color: #41CBAA;
						}

					}
				}
				.t_title {
					width: 100%;
					background-color: #41CBAA;
					border: 1px solid #C8CED7;
					color: #fff;
					line-height: 45px;
					font-size: 20px;
					text-align: center;
				}

			}
		}
		.detail {
			font-size: 18px;
			text-align: center;
			span {
				font-size: 22px;
				font-weight: bold;
				color: #DF6800;
			}
		}
	}
</style>
